import React, { useEffect } from "react";
import { sosContent, SOS_INICIO_ISO, SOS_FIM_ISO } from "./content";
import { Reveal } from "./components/base";
import { BarraMobile, Beneficios, Faq, Hero, Programacao, ProvaSocial } from "./components/Sections";
import "./sos-base.css";
import "./sos.css";

/*
 * LP de inscrição do SOS Aprova 2026 (rota /). Porte da landing /sos-aprova do
 * projeto de LPs (wisereducacao-landing-pages, branch
 * feat/lps-esquenta-cronograma-aulao, 23/10/2026). Textos e datas em content.js;
 * estilos em sos.css (cópia da original) + sos-base.css (o reset que ela espera).
 */

const FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&family=Noto+Sans:wght@400;500;700&family=Anton&display=swap";

const PAGE_URL = "https://sos.aprovatotal.com.br/";
const TITLE = "SOS Aprova 2026: revisão pré-Enem ao vivo e grátis | Aprova Total";
const DESCRIPTION =
  "De 2 a 14 de novembro, duas semanas de aulões ao vivo e gratuitos com os professores do Aprova Total: materiais, simulados no padrão Enem e simulador TRI.";

const eventoJsonLd = {
  "@context": "https://schema.org",
  "@type": "EducationalEvent",
  "@id": `${PAGE_URL}#evento`,
  name: "SOS Aprova 2026: revisão pré-Enem ao vivo",
  description: sosContent.resumo,
  inLanguage: "pt-BR",
  image: `${PAGE_URL}images/sos-aprova/og-image.jpg`,
  url: PAGE_URL,
  startDate: SOS_INICIO_ISO,
  endDate: SOS_FIM_ISO,
  eventAttendanceMode: "https://schema.org/OnlineEventAttendanceMode",
  eventStatus: "https://schema.org/EventScheduled",
  isAccessibleForFree: true,
  location: { "@type": "VirtualLocation", url: PAGE_URL },
  organizer: { "@type": "EducationalOrganization", name: "Aprova Total", url: "https://aprovatotal.com.br" },
  audience: { "@type": "EducationalAudience", educationalRole: "student", audienceType: "Estudantes que vão prestar o Enem" },
  teaches: sosContent.beneficios.itens.map((i) => i.label),
  offers: { "@type": "Offer", price: "0", priceCurrency: "BRL", availability: "https://schema.org/InStock", url: `${PAGE_URL}#inscricao`, validFrom: "2026-10-02T00:00:00-03:00" },
  potentialAction: { "@type": "RegisterAction", name: "Inscrição gratuita no SOS Aprova", target: `${PAGE_URL}#inscricao` },
};

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: sosContent.faq.itens.map((it) => ({ "@type": "Question", name: it.q, acceptedAnswer: { "@type": "Answer", text: it.a } })),
};

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  const before = el.getAttribute("content");
  el.setAttribute("content", content);
  return () => before !== null && el.setAttribute("content", before);
};

export default function LandingSos() {
  // Quem chega por /#inscricao (ex.: vindo do /ao-vivo) cai direto no formulário.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    const el = id && document.getElementById(id);
    if (el) window.setTimeout(() => el.scrollIntoView({ block: "start" }), 300);
  }, []);

  useEffect(() => {
    if (!document.querySelector(`link[href="${FONTS_HREF}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = FONTS_HREF;
      document.head.appendChild(link);
    }
    const title = document.title;
    document.title = TITLE;
    const restoreDesc = setMeta("description", DESCRIPTION);
    return () => {
      document.title = title;
      restoreDesc();
    };
  }, []);

  return (
    <div className="sos">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(eventoJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
      <div className="sos-grain" aria-hidden="true" />
      <Hero />
      <main>
        <Beneficios />
        <Programacao />
        <ProvaSocial />
        <Faq />
      </main>
      <BarraMobile />
      <Reveal />
    </div>
  );
}
